import styled from 'foundations-theming/utils';
import { Alert } from '../Alert';
import { StyledAlertTitle } from '../Alert/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAlertContainer = styled.div.withConfig({
  displayName: "Banner__StyledAlertContainer",
  componentId: "sc-1qyg3iy-0"
})(() => ({
  [`& ${StyledAlertTitle}}`]: {
    alignSelf: 'inherit',
    flexGrow: 1
  }
}));
export const Banner = props => {
  return /*#__PURE__*/_jsx(StyledAlertContainer, {
    children: /*#__PURE__*/_jsx(Alert, Object.assign({
      type: "banner"
    }, props))
  });
};